export * from "-!../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=template&id=4c7fd7fd"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/settings/bonuses/index.vue?vue&type=template&id=4c7fd7fd
// module id = jOpG
// module chunks = 0